<div class="selectAll">
  @if (
    ppSite &&
    ppNumberOfSelectableFields !==
    ppSelectedCustomFields[ppSite.accountId][ppSite.workspaceId].length
    ) {
    <button
      (click)="selectAll()"
      >
      {{ 'select_all' | ppTranslate }}
    </button>
  }

  @if (
    ppSite &&
    ppNumberOfSelectableFields ===
    ppSelectedCustomFields[ppSite.accountId][ppSite.workspaceId].length &&
    ppNumberOfSelectableFields !== 0
    ) {
    <button
      (click)="deselectAll()"
      >
      {{ 'deselect_all' | ppTranslate }}
    </button>
  }

  @if (
    ppSite &&
    ppNumberOfSelectableFields ===
    ppSelectedCustomFields[ppSite.accountId][ppSite.workspaceId].length &&
    ppNumberOfSelectableFields === 0
    ) {
    <button
      class="selectAll--disabled"
      (click)="selectAll()"
      >
      {{ 'select_all' | ppTranslate }}
    </button>
  }
</div>
